<template>
  <roe-error-message :field="design.employer_other_dollar_maximum_amount">
    <input
      name="employer_other_dollar_maximum_amount"
      type="number"
      v-model.number="design.$model.employer_other_dollar_maximum_amount"
    />
    <label class="input-label-inside">$</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherDollarMaximumInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
